import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  dialogPaper: {
    minHeight: 321,
  },
}));

export default useStyles;
